import React from 'react';
import { BriefcaseBusiness, Users, Handshake } from 'lucide-react';
import SectionHeader from './SectionHeader';

const pillars = [
  {
    icon: BriefcaseBusiness,
    title: 'For Clients',
    description:
      'We help businesses find the right talent based on requirements, budget, and timeline so hiring becomes faster and more reliable.',
  },
  {
    icon: Users,
    title: 'For Freelancers',
    description:
      'Freelancers get access to genuine projects, better visibility, and more consistent work opportunities through one trusted platform.',
  },
  {
    icon: Handshake,
    title: 'Broker-Supported Matching',
    description:
      'Our broker-supported matching system improves the quality of connections, speeds up hiring, and supports trusted outcomes.',
  },
];

const About = () => {
  return (
    <section id="about" className="py-28 md:py-32 relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-0 top-16 h-80 w-80 rounded-full bg-cyan-500/10 blur-[120px]"></div>
        <div className="absolute right-0 bottom-0 h-80 w-80 rounded-full bg-blue-500/10 blur-[120px]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 lg:px-8">
        <SectionHeader
          eyebrow="About Kaamhub"
          title="A Smart Platform for"
          accent="Clients and Freelancers"
          className="mb-10 md:mb-12"
        />

        <div className="mx-auto mb-12 max-w-8xl rounded-[2rem] border border-slate-200/80 bg-white/85 p-8 text-center shadow-xl backdrop-blur-sm dark:border-white/10 dark:bg-slate-900/75 md:p-10">
          <div className="space-y-5">
            <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-300">
              We provide a smart platform that connects clients with skilled freelancers quickly and efficiently. Whether you are a business looking for reliable services or a freelancer searching for work opportunities, our platform makes the process simple and fast.
            </p>

            <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-300">
              We help clients find the right talent based on their requirements, budget, and timeline, while freelancers get access to genuine projects and consistent work.
            </p>

            <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-300">
              With our broker-supported matching system, we ensure better connections, faster hiring, and trusted outcomes.
            </p>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;

            return (
              <div
                key={pillar.title}
                className="rounded-[1.75rem] border border-slate-200/80 bg-white/85 p-7 text-center shadow-lg backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl dark:border-white/10 dark:bg-slate-900/75"
              >
                <div className="mb-5 flex justify-center">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-cyan-500 shadow-lg">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                </div>
                <h3 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white">
                  {pillar.title}
                </h3>
                <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
